// Editor.js block registry. The www build aliases each block's editorBlocks/<X>/index.js
// module to its public View.svelte; the admin scrapes the default imports below with a
// plain regex (never quote the import pattern in comments).
import header from '@reperio-news/core.components/editorBlocks/Header/index.js';
import image from '@reperio-news/core.components/editorBlocks/Image/index.js';
import imageGallery from '@reperio-news/core.components/editorBlocks/ImageGallery/index.js';
import video from '@reperio-news/core.components/editorBlocks/Video/index.js';
import embed from '@reperio-news/core.components/editorBlocks/Embed/index.js';
import raw from '@reperio-news/core.components/editorBlocks/Raw/index.js';
import list from '@reperio-news/core.components/editorBlocks/List/index.js';
import hr from '@reperio-news/core.components/editorBlocks/Hr/index.js';
import blockquote from '@reperio-news/core.components/editorBlocks/BlockQuote/index.js';
import table from '@reperio-news/core.components/editorBlocks/Table/index.js';
import chart from '@reperio-news/core.components/editorBlocks/Chart/index.js';

export default {
	header,
	image,
	imageGallery,
	video,
	embed,
	raw,
	list,
	hr,
	blockquote,
	table,
	chart,
};

import * as VideoPlayerDefaultView from '@reperio-news/adh-www-common/src/shared/editorBlocks/Video/Default.svelte';
import * as ImageGalleryDefaultView from '@reperio-news/adh-www-common/src/shared/editorBlocks/ImageGallery/Default.svelte';

// ADH island views (the core video view renders "not available" without an override)
export const DOMAIN_VIEWS = {
	video: { default: VideoPlayerDefaultView },
	imageGallery: { default: ImageGalleryDefaultView },
};
